import { render, staticRenderFns } from "./AddReminder.vue?vue&type=template&id=d6f131ec&scoped=true&"
import script from "./AddReminder.vue?vue&type=script&lang=js&"
export * from "./AddReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f131ec",
  null
  
)

export default component.exports